exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.input .react-datepicker-wrapper .react-datepicker__input-container input[type='text'].open-order-report--date-picker {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/reports/inventory/openordersreport.less
// module id = 3736
// module chunks = 0